/*
常用的方法
- 日期格式化
- 设置元素滚动
- 导出功能
-  ?图片自由伸缩功能，预览时
*/
import APIDOC from "@/api/model/serverApi.js";
import { getCookie, getStore } from './cache';
import Msg from "./msg";

/**
 *
 * @export
 * @param {*} msec
 * @return {*}
 * //变量
// let myTime1 = 1628990100000;
// let myTime2 = 'Sun Aug 15 2021 09:15:00 GMT+0800 (中国标准时间)';
 */
export function formatDate(msec) {
    let datetime = new Date(msec);
    let year = datetime.getFullYear();
    let month = datetime.getMonth();
    let date = datetime.getDate();
    let hour = datetime.getHours();
    let minute = datetime.getMinutes();
    let second = datetime.getSeconds();
    let result1 = year +
        '-' +
        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
        '-' +
        ((date + 1) <= 10 ? '0' + date : date) +
        ' ' +
        ((hour + 1) <= 10 ? '0' + hour : hour) +
        ':' +
        ((minute + 1) <= 10 ? '0' + minute : minute) +
        ':' +
        ((second + 1) <= 10 ? '0' + second : second);

    let result2 = year +
        '-' +
        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
        '-' +
        ((date + 1) < 10 ? '0' + date : date);

    let result = {
        hasTime: result1,
        withoutTime: result2
    };

    return result;
}
//例子
// console.log(formatDate(myTime1).hasTime);//2021-08-15 9:15:00
// console.log(formatDate(myTime1).withoutTime);//2021-08-15
// console.log(formatDate(myTime2).hasTime);//2021-08-15 9:15:00
// console.log(formatDate(myTime2).withoutTime);//2021-08-15



/**
 *在需要滚动的元素中设置 @mousewheel 方法，调用此处方法即可实现横向滚动
 *
 *
 * @param {Event} event 数据源对象
 * @param {number} [type=1] 决定横向或者纵向 (0/1)，默认纵向滚动
 * @param {dom} refDom dom对象
 */
export function handlerMouserScroll(event, type = 1, refDom) {
    event.stopPropagation();
    event.preventDefault();
    const documentObj = refDom || document.documentElement;
    let detail = event.wheelDelta || event.detail;
    let moveForwardStep = -1;
    let moveBackStep = 1;
    let step = 0;
    step = detail > 0 ? moveForwardStep * 100 : moveBackStep * 100;
    type == 1 ? documentObj.scrollTop += step : documentObj.scrollLeft = documentObj.scrollLeft + step;
}

export function formatTime2Locase(s) {//单位：秒

    if (s === undefined) return 0;
    const hours = parseInt(s / 3600);
    const minutes = parseInt((s % 3600) / 60);
    const seconds = parseInt(s % 60);
    // console.info(s)
    // console.info(hours+':'+minutes+':'+seconds)
    return seconds == 0 && minutes ==0 && hours==0 ? 0 : (`${hours}小时 : ${minutes}分钟 : ${seconds}秒`);
}

export function transferParams2Str(obj) {
    let str = '?';
    Object.keys(obj).forEach(key => {
        str += `${key}=${obj[key]}&`;
    });
    return str.substring(0, str.length - 1);
}

export function downloadFile(url, fileName = '导出') {
    const xhr = new XMLHttpRequest();
    const token = getStore('token');
    xhr.open('POST', url, true);
    xhr.setRequestHeader("Authorization", token);
    xhr.responseType = 'blob';
    console.log('xhr创建成功', xhr);

    xhr.onload = function (e) {
        console.log('e==>', e);

        //如果请求执行成功
        if (this.status == 200) {
            var blob = this.response;
            var a = document.createElement('a');
            // blob.type = "application/octet-stream";
            //创键临时url对象
            var url = URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            //释放之前创建的URL对象
            window.URL.revokeObjectURL(url);
        }
    }
}

/*******
 * @description: 导出excel
 * @param {*} min
 * @param {*} max
 * @return {*}
 */
export function download(url, RQO = {}, fileName) {
    const res = window.confirm("确定导出？")
    if (!res) return;
    Msg({
        code: 100,
        msg: "即将导出，请稍等！"
    });
    const path = APIDOC.BASEURL + url;
    const paramStr = transferParams2Str(RQO);
    console.log('download', url, path, paramStr, fileName);
    downloadFile(path + paramStr, fileName);
}



// WEBPACK FOOTER //
// ./src/utils/defaultUtils.js